const topics = [
  { label: '影视大全', heat: '32.8万', icon: 'ri-fire-line' },
  { label: '热门视频', heat: '28.1万', icon: 'ri-fire-line' },
  { label: '视频合集', heat: '25.6万', icon: 'ri-fire-line' },
  { label: '妖精视频', heat: '23.4万', icon: 'ri-line-chart-line' },
  { label: '桃花视频', heat: '19.8万', icon: 'ri-line-chart-line' },
  { label: '苹果视频', heat: '17.2万', icon: 'ri-line-chart-line' },
  { label: '榴莲视频', heat: '15.1万', icon: 'ri-lightbulb-flash-line' },
  { label: '豆花视频', heat: '12.6万', icon: 'ri-lightbulb-flash-line' },
  { label: '高清资源', heat: '10.3万', icon: 'ri-star-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门话题</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              影视大全热门视频合集话题热度追踪，发现大家都在关注什么
            </p>
          </div>

          <div className="space-y-3">
            {topics.map((topic, i) => (
              <div
                key={i}
                className="flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer group"
              >
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  i < 3 ? 'bg-primary-100 text-primary-600' : 'bg-secondary-100 text-secondary-600'
                }`}>
                  <i className={`${topic.icon} text-sm`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    #{topic.label}
                  </h3>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <div className="h-1.5 w-20 md:w-28 bg-background-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-accent-400 rounded-full transition-all"
                      style={{ width: `${100 - i * 8}%` }}
                    ></div>
                  </div>
                  <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">{topic.heat}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}